import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Webinar } from '@shared/interfaces/educational-section/webinar.interface';
import { EducationalSectionService } from '@shared/service/educational-section/educational-section.service';
import { SnackbarService } from '@shared/service/snackbar/snackbar.service';
import { genericErrorAction } from '@store/application/application.actions';
import { educationalSection } from '@store/educational-section/educational-section.actions';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class EducationalSectionEffects {
  loadWebinars = createEffect(() =>
    this.actions$.pipe(
      ofType(educationalSection.load),
      switchMap(() =>
        this.educationalSectionService.getWebinars().pipe(
          map((response: Array<Webinar>) => educationalSection.loadSuccess({ webinars: response })),
          catchError(() => of(genericErrorAction({})))
        )
      )
    )
  );

  loadPumpById = createEffect(() =>
    this.actions$.pipe(
      ofType(educationalSection.loadWebinar),
      switchMap((payload: { id: number }) =>
        this.educationalSectionService.getWebinarById(payload.id).pipe(
          map((response: Webinar) => educationalSection.loadWebinarSuccess({ webinar: response })),
          catchError(() => of(genericErrorAction({})))
        )
      )
    )
  );

  deletePump = createEffect(() =>
    this.actions$.pipe(
      ofType(educationalSection.delete),
      switchMap((payload: { webinar: Webinar }) =>
        this.educationalSectionService.deleteWebinar(payload.webinar.id).pipe(
          map(() => {
            console.log(`Deleted - ${payload.webinar.title}`);
            this.snackbarService.success(`Deleted - ${payload.webinar.title}`);
            return educationalSection.load();
          }),
          catchError(() => of(genericErrorAction({})))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly educationalSectionService: EducationalSectionService,
    private readonly snackbarService: SnackbarService
  ) {}
}
